export var AlertChannelKind;
(function (AlertChannelKind) {
    AlertChannelKind["ALERT_CHANNEL_KIND_UNSPECIFIED"] = "ALERT_CHANNEL_KIND_UNSPECIFIED";
    AlertChannelKind["ALERT_CHANNEL_KIND_PAGERDUTY"] = "ALERT_CHANNEL_KIND_PAGERDUTY";
    AlertChannelKind["ALERT_CHANNEL_KIND_SLACK"] = "ALERT_CHANNEL_KIND_SLACK";
    AlertChannelKind["ALERT_CHANNEL_KIND_EMAIL"] = "ALERT_CHANNEL_KIND_EMAIL";
})(AlertChannelKind || (AlertChannelKind = {}));
